const company = {
	banner: [{
		tips:'认证企业信息',
		title:'认证企业信息',
		content:'',
		img: require('@/assets/img/index/GPI_2x.png'),
		url: require('@/assets/img/index/banner01.png'),
	}],
	label:{
		serialNo:'统一社会信用代码',
		deptName:'企业名称',
		email:'公司邮箱',
		address:'住所地',
		leader:'法定代表人',
		contact:'联系人',
		phone:'联系电话',
		zipCode:'邮编',
		cardNo:'证件号',
		describes:'企业简介',
		licenseId:'上传营业执照',
		ticketId:'上传开票信息',
		rzzm:'任职证明',
		sfzm:'身份证复印件',
		b_tips:'上传仅支持jpg和png格式，彩色扫描件或复印件加红色公章，文件大小不超过100M',
		s_tips:'上传仅支持jpg和png格式，需加盖公章，文件大小不超过100M',
		rzzm_tips:'上传仅支持jpg和png格式，文件大小不超过100M',
		sfzm_tips:'上传仅支持jpg和png格式，文件大小不超过100M',
		down:'下载开票信息模板',
		submit:'提交',
		reset:'重置',
		status:'认证状态'
	},
	placeholder:{
		serialNo:'请输入统一社会信用代码',
		deptName:'请输入企业名称',
		email:"请输入公司邮箱",
		address:'请输入住所地',
		leader:'请输入法定代表人',
		contact:'请输入联系人',
		phone:'请输入电话',
		zipCode:'请输入邮编',
		cardNo:'请输入证件号',
		describes:'请输入企业简介',
		licenseId:'请上传营业执照',
		ticketId:'请上传开票信息',				
	},
	rules:{
		serialNo:	[
			{ required: true, message:'请输入统一社会信用代码', trigger: 'blur' },
			{ pattern: /^[a-zA-Z0-9]+$/, message: "请输入正确的数字或字母",trigger: "blur"}
		],
		deptName:	[{ required: true, message:'请输入企业名称', trigger: 'blur' },],	
		email: [
			{ required: true, message:'请输入公司邮箱', trigger: 'blur' },
			{ pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/, message: "请输入正确的邮箱地址", trigger: ["blur", "change"]}
		],
		address:	[{ required: true, message:'请输入住所地', trigger: 'blur' },],
		leader:	[{ required: true, message:'请输入法定代表人', trigger: 'blur' },],
		contact:	[{ required: true, message:'请输入联系人', trigger: 'blur' },],
		phone:	[
			{ required: true, message:'请输入电话', trigger: 'blur' },
			{ pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/, message: "请输入正确的手机号码",trigger: "blur"}
		], 
		zipCode: [
			{ required: true, message:'请输入邮编', trigger: 'blur' },
			{ pattern: /[1-9]\d{5}(?!\d)/, message: "请输入正确的邮编",trigger: "blur"}
		],
		licenseId:	[{ required: true, message:'请上传营业执照', trigger: 'blur' },],
		ticketId:	[{ required: true, message:'请上传开票信息', trigger: 'blur' },],
		rzzm:[{ required: true, message:'请上传任职证明', trigger: 'change' },],
		sfzm:[{ required: true, message:'请上传身份证复印件', trigger: 'change' },],
	}	
}

export default company
